import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

/**
 * DS Popover — figma 1100:26897 (대시보드 리뉴얼 help popover).
 *
 * 물음표(도움말) 트리거 + 다크 반투명 팝오버(제목/설명). 컬럼 헤더·액션바의
 * 설명용 공통 컴포넌트(우진 7/23). hover/focus 로 열리고 클릭 토글도 지원.
 *
 * 시각: bg rgba(22,25,29,.7) + blur(8), radius 12, padding 12, gap 6,
 *       제목 SemiBold 14/1.28 #FDFDFD, 본문 14/1.48 #D3D3D3 (figma 변수 --700/--20)
 *
 * @param {object} props
 * @param {string} [props.title]
 * @param {React.ReactNode} props.description - 설명(문자열 \n 줄바꿈 지원)
 * @param {"bottom"|"top"} [props.placement="bottom"]
 * @param {string} [props.className]
 */
const DSPopover = ({ title, description, placement = "bottom", className = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <span
      className={`ds-popover ${className}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="ds-popover__trigger"
        aria-label={title || "도움말"}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        <FontAwesomeIcon icon={faCircleQuestion} />
      </button>
      {open && (
        <span
          className={`ds-popover__panel ds-popover__panel--${placement}`}
          role="tooltip"
        >
          {title && <span className="ds-popover__title">{title}</span>}
          <span className="ds-popover__desc">{description}</span>
        </span>
      )}
    </span>
  );
};

export default React.memo(DSPopover);
